import {InputGroupContainer} from '@app/lui2/InputGroup';
import {colorVar} from '@app/lui2/Theme/colors';
import styled from 'styled-components';

const AbsLayer = styled.div`
  position: absolute;
  inset: 0;
  border-radius: var(--btn-radius);
  overflow: clip;

  ${InputGroupContainer} > :not(:first-child) & {
    border-inline-start: solid var(--theme-border-thickness)
      ${colorVar('surface')};
    border-start-start-radius: 0;
    border-end-start-radius: 0;
    margin-inline-start: calc(-1 * var(--theme-border-thickness));
  }
  ${InputGroupContainer} > :not(:last-child) & {
    border-inline-end: solid var(--theme-border-thickness)
      ${colorVar('surface')};
    border-start-end-radius: 0;
    border-end-end-radius: 0;
  }
`;

export default AbsLayer;
